export const buildMoodleLanguageLinksPayload = (partCode, version, revision, selection) => {
  if (!selection || typeof selection !== 'object') {
    return null;
  }

  const variants = Array.isArray(selection.variants)
    ? selection.variants
        .filter(variant => variant?.moodleCourseId)
        .map(variant => ({
          language: String(variant.language || '')
            .trim()
            .toLowerCase(),
          moodleCourseId: variant.moodleCourseId,
          moodleActivityId: variant.moodleActivityId,
        }))
    : [];

  return {
    moduleCode: String(partCode || selection.moduleCode || '').trim(),
    version: String(version || selection.version || '').trim(),
    revision: String(revision ?? selection.revision ?? '0').trim(),
    variants,
  };
};

export const mapMoodleLinksToFormSelection = (links, partCode, version, revision) => {
  const emptySelection = {
    moduleCode: '',
    version: '',
    revision: '',
    variants: [],
  };

  if (!links) {
    return emptySelection;
  }

  if (Array.isArray(links)) {
    if (!links.length) {
      return emptySelection;
    }
    const first = links[0];
    return {
      moduleCode: String(first?.moduleCode || partCode || '').trim(),
      version: String(first?.version || version || '').trim(),
      revision: String(first?.revision ?? revision ?? '0').trim(),
      variants: links.map(variant => ({
        language: String(variant.language || '')
          .trim()
          .toLowerCase(),
        moodleCourseId: variant.moodleCourseId,
        moodleActivityId: variant.moodleActivityId,
      })),
    };
  }

  const variants = Array.isArray(links.variants) ? links.variants : [];
  if (!variants.length) {
    return emptySelection;
  }

  return {
    moduleCode: String(links.moduleCode || partCode || '').trim(),
    version: String(links.version || version || '').trim(),
    revision: String(links.revision ?? revision ?? '0').trim(),
    variants: variants.map(variant => ({
      language: String(variant.language || '')
        .trim()
        .toLowerCase(),
      moodleCourseId: variant.moodleCourseId,
      moodleActivityId: variant.moodleActivityId,
    })),
  };
};
